import { ErrorLogComponent } from '@cian/error-log-component';
import { Spinner } from '@cian/ui-kit';

import loadable from '@loadable/component';
import { useEffect, useMemo } from 'react';

import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';
import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

import { useListingAppContext } from '../../context/ListingAppContext';
import { type TInitCardApiContext } from '../../types/TCardApiContext';
import { type TCardContextData } from '../../types/TCardContextData';

import { CardContexts } from './containers/desktop/CardContexts';

/**
 * @todo объединить компоненты в один
 * удобно разделять на 2 отдельных компонента, но это плохо сказывается на performance переключения гибридного и широкого режима
 */
const CardWide = loadable(() => import('./flat-rent/FlatRentCardWide'), {
  resolveComponent: module => module.FlatRentCardWide,
  fallback: <Spinner />,
  ssr: true,
});

const CardNarrow = loadable(() => import('./flat-rent/FlatRentCardNarrow'), {
  resolveComponent: module => module.FlatRentCardNarrow,
  fallback: <Spinner />,
  ssr: true,
});

type ResidentialWithContextProps = TCardContextData & {
  initCardApi: TInitCardApiContext;
};

export const ResidentialCard = memoWithDisplayName<ResidentialWithContextProps>(
  ({ dealType, index, initCardApi, offer }) => {
    const cardContextData = useMemo(() => ({ dealType, index, offer }), [dealType, index, offer]);
    const { logger } = useListingAppContext();
    const isNarrow = useListingLayoutIsNarrowSelector();

    /**
     * Предварительная загрузка другой версии карточки, чтобы избежать мерцания при переключении между широкими и узкими карточками
     */
    useEffect(() => {
      if (isNarrow) {
        CardWide.load();
      } else {
        CardNarrow.load();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <ErrorLogComponent level="error" logger={logger}>
        <CardContexts cardContextData={cardContextData} initCardApi={initCardApi}>
          {isNarrow ? <CardNarrow /> : <CardWide />}
        </CardContexts>
      </ErrorLogComponent>
    );
  },
  'FlatRentCard',
);
